module.exports = __webpack_public_path__ + "img/undraw_personal_information_re_vw8a.c14b3254.svg";